import { DependentCareCreditLevel } from '../../../types';

export const stateDependentCareIA2026: DependentCareCreditLevel[] = [
    {
        "minimumIncome": 0.00000000000000000000,
        "maximumIncome": 10000.0000000000000000,
        "percentage": 0.75
    },
    {
        "minimumIncome": 10000.0100000000000000,
        "maximumIncome": 20000.000000000000,
        "percentage": 0.65
    },
    {
        "minimumIncome": 20000.010000000000,
        "maximumIncome": 25000.000000000000,
        "percentage": 0.55
    },
    {
        "minimumIncome": 25000.010000000000,
        "maximumIncome": 35000.000000000000,
        "percentage": 0.5
    },
    {
        "minimumIncome": 35000.010000000000,
        "maximumIncome": 40000.000000000000,
        "percentage": 0.4
    },
    {
        "minimumIncome": 40000.010000000000,
        "maximumIncome": 90000.000000000000,
        "percentage": 0.3
    },
    {
        "minimumIncome": 90000.010000000000,
        "maximumIncome": 999999999999999999.00000000000000000000,
        "percentage": 0.0
    }

];